const Footer = () => {
    return (
        <div className="flex w-full flex-col items-center justify-between px-1 pb-8 pt-3 lg:px-8 xl:flex-row">
            <p className="mb-4 text-center text-xs font-medium text-gray-600 sm:!mb-0 md:text-lg">
                <span className="mb-4 text-center text-xs text-gray-600 sm:!mb-0 md:text-xs">
                    ©{new Date().getFullYear()} DuckFlow. All Rights Reserved.
                </span>
            </p>
            <div>
                <ul className="flex flex-wrap items-center gap-3 sm:flex-nowrap md:gap-10">
                    <li>
                        <a
                            target="blank"
                            href="https://go.crisp.chat/chat/embed/?website_id=3ccc648a-6971-42b8-abc7-f2150480954f"
                            className="text-xs font-medium text-gray-600 hover:text-gray-600"
                        >
                            Support
                        </a>
                    </li>
                    <li>
                        <a
                            target="blank"
                            href="/policy"
                            className="text-xs font-medium text-gray-600 hover:text-gray-600"
                        >
                            Terms of Use
                        </a>
                    </li>
                    <li>
                        <a
                            target="blank"
                            href="https://DuckFlow.io/blog/"
                            className="text-xs font-medium text-gray-600 hover:text-gray-600"
                        >
                            Blog
                        </a>
                    </li>
                    <li>
                        <a
                            target="blank"
                            href="https://DuckFlow.io/blog/"
                            className="text-xs font-medium text-gray-600 hover:text-gray-600"
                        >
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default Footer;
